import { Component, inject } from '@angular/core';
import {
  AdminStammdatenDeaktivierungsgrundEntryComponent
} from '@app/admin/stammdaten/deaktivierungsgrund/admin-stammdaten-deaktivierungsgrund-entry/admin-stammdaten-deaktivierungsgrund-entry.component';
import {
  AdminStammdatenDeaktivierungsgrundNewComponent
} from '@app/admin/stammdaten/deaktivierungsgrund/admin-stammdaten-deaktivierungsgrund-new/admin-stammdaten-deaktivierungsgrund-new.component';
import { BackendService } from '@app/shared/services/backend.service';
import { TranslatePipe } from '@ngx-translate/core';
import { rxResource } from "@angular/core/rxjs-interop";

@Component({
  selector: 'app-admin-stammdaten-deaktivierungsgrund',
  templateUrl: './admin-stammdaten-deaktivierungsgrund.component.html',
  imports: [
    AdminStammdatenDeaktivierungsgrundNewComponent,
    AdminStammdatenDeaktivierungsgrundEntryComponent,
    TranslatePipe,
  ],
})
export class AdminStammdatenDeaktivierungsgrundComponent {
  private readonly backendService = inject(BackendService);

  protected readonly gruende = rxResource({ defaultValue: [], stream: () => this.backendService.listDeaktivierungsGruendeAdmin() });

  onGrundDeleted(id: number) {
    this.gruende.update( list =>
      list.filter( grund => grund.id !== id )
    );
  }
}
